import { CustomerFilterLanguage } from 'src/app/core/class/customer-filter-language';
import { Component, OnInit, OnDestroy, ViewChild, ViewChildren, AfterViewInit } from '@angular/core';
import { CustomerService } from 'src/app/core/services/customer.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { NotificationService } from 'src/app/core/services/notification.service';
import { CommonService } from 'src/app/core/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UploadMultiFileComponent } from 'src/app/shared/components/upload-multi-file/upload-multi-file.component';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { EnterpriseTypes } from 'src/app/core/constants/enterprise-type';
import { Message } from 'src/app/core/class/message';
import {environment} from "../../../../../../../../environments/environment";
import { EnvService } from 'src/app/core/services/env.service';
import { format } from 'date-fns';
import { DateParseService } from 'src/app/core/services/date-parse.service';

@Component({
  selector: 'app-view-customer',
  templateUrl: './view-customer.component.html',
  styleUrls: ['./view-customer.component.scss']
})
export class ViewCustomerComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChildren('focus') focus;
  @ViewChild(UploadMultiFileComponent, { read: UploadMultiFileComponent, static: false }) uploadMultiFileComponent;
  // Variable for saving userType from session storage of current user
  userType: number;
  isView: boolean = true;
  personalId = EnterpriseTypes.PERSONAL;
  certificate: any;
  certificateType: any;
  representativeCertificateType: any;
  representativeCertificate: any;
  representativeCertificateName: any;
  customer = {
    id: null,
    enterpriseId: localStorage.getItem('enterpriseId'),
    primaryEmail: null,
    customerType: 0,
    name: '',
    status: null,
    certificateId: null,
    certificateNo: '',
    issuedDate: null,
    issuedAt: '',
    taxCode: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeIssuedDate: '',
    representativeIssuedAt: '',
    birthday: null,
    sex: null,
    accountNumber: '',
    accountName: '',
    bankName: '',
    bankBranch: '',
    phone: '',
    fax: '',
    email: '',
    address: '',
    cityId: null,
    wardId: null,
    districtId: null,
    attachments: [],
    attachmentImages: [],
    adminUser: '',
    hasPermission: true,
    customerCode:null,
    birthdayDisplay: '',
    issuedDateDisplay: '',
    representativeIssuedDateDisplay: '',
    isNewAddress: true
  };
  customerType: any;
  subscription: Subscription;
  cities: { id: number, name: '', description: '' }[];
  districts: { id: number, cityId: number, name: '', description: '' }[];
  wards: { id: number, districtId: number, name: '', description: '' }[];
  addresses = {
    cityName: '',
    districtName: '',
    wardName: ''
  };
  enterpriseType: [{
    id: number,
    name: '',
    langs: []
  }];
  searchtenantId: '';
  searchPage: number;
  searchPageSize: number;
  searchEnterpriseId: '';
  searchTaxCodeOrCertificateNo: '';
  searchKeyword: '';
  searchStatus: [];
  searchEnterpriseTypeId: number;
  permissions: any;
  isShowInfor: boolean = true
  currentTab = 0;
  isInforTab = 0
  readonly = true;
  isNotAttestedUser: boolean = false;
  sme_hub:any
  cityList: any[] = []
  districtList: any[] = []
  wardList: any[] = []
  listBankName: any[] = []
  constructor(
    private customerService: CustomerService,
    public notificationService: NotificationService,
    public commonService: CommonService,
    private route: ActivatedRoute,
    private breadcrumbsService: BreadcrumbsService,
    private router: Router,
    private storageService: StorageService,
    public customerFilter: CustomerFilterLanguage,
    private env:EnvService
  ) {
    this.customer.id = this.route.snapshot.paramMap.get('id');
    this.permissions = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : [];
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
    this.sme_hub = env.sme_portal_url
  }

  /**
   * Get initial data
   */
  ngOnInit() {
    // this.getCities();
    // this.getDistricts();
    // this.getWards();
    this.setUserType();
    this.getBankName();
    this.commonService.getCategory().subscribe(result => {
      this.cityList[1] = result[0].data.filter(item => !item.isNew)
      this.districtList[1] = result[1].data.filter(item => !item.isNew)
      this.wardList[1] = result[2].data.filter(item => !item.isNew)
      this.cityList[0] = result[3].data
      this.districtList[0] = []
      this.wardList[0] = result[4].data;
      this.cities = result[0].data;
      this.districts = result[1].data;
      this.wards = result[2].data;
      this.getCustomer(this.customer.id);
    })
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);
    this.breadcrumbsService.store([
      { label: 'breadcrumbs.home', url: 'analysis-report', params: [], highlight: false },
      { label: 'breadcrumbs.management_customer', url: '', params: [], highlight: false },
      { label: 'breadcrumbs.enterprise_customer', url: 'customers', params: [], highlight: false },
      { label: 'breadcrumbs.customer_info', url: 'view-customer/:id', params: [this.customer.id], highlight: false },
    ]);

    this.subscription = this.route
      .queryParams
      .subscribe(params => {
        // Defaults to 0 if no query param provided.
        // this.page = +params['page'] || 0;
        this.searchtenantId = params.tenantId || 0;
        this.searchPage = params.page || 0;
        this.searchPageSize = params.pageSize || 0;
        this.searchEnterpriseId = params.enterpriseId || '';
        this.searchKeyword = params.keyword || '';
        this.searchEnterpriseTypeId = params.enterpriseTypeId;
        this.searchStatus = params.status;
        this.searchTaxCodeOrCertificateNo = params.taxCodeOrCertificateNo || '';
      });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focus.first.nativeElement.focus());
  }

  getBankName() {
    this.commonService.getBankName().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.listBankName = result;
      }
    });
  }

  /**
   * Get cities list from local storage or api
   */
  getCities() {
    if (localStorage.getItem('cities') === null) {
      this.commonService.getAllCityRedis().subscribe(rs => {
        this.cities = rs.data;
        localStorage.setItem(
          'cities',
          JSON.stringify(this.cities),
        );
      });
    } else {
      this.cities = JSON.parse(
        localStorage.getItem('cities')
      );
    }
  }

  /**
   * Get districts list from local storage or api
   */
  getDistricts() {
    if (localStorage.getItem('districts') === null) {
      this.commonService.getAllDistrictsRedis().subscribe(rs => {
        this.districts = rs.data;
        localStorage.setItem(
          'districts',
          JSON.stringify(this.districts),
        );
      });
    } else {
      this.districts = JSON.parse(
        localStorage.getItem('districts')
      );
    }
  }

  /**
   * Get wards list from local storage or api
   */
  getWards() {
    if (localStorage.getItem('wards') === null) {
      this.commonService.getAllWardRedis().subscribe(rs => {
        this.wards = rs.data;
        localStorage.setItem(
          'wards',
          JSON.stringify(this.wards),
        );
      });
    } else {
      this.wards = JSON.parse(
        localStorage.getItem('wards')
      );
    }
  }

  /**
   * Call api to get customer by id
   * @param id: number
   */
  getCustomer(id: number) {
    this.customerService.getCustomer(id).subscribe(
      rs => {
        if (rs == null || rs.data == null) {
          return 0;
        }
        this.customer = {
          ...this.customer,
          ...rs.data,
          birthday: rs.data.birthday != null ? DateParseService.parseDate(rs.data.birthday) : null,
          issuedDate: rs.data.issuedDate != null ? DateParseService.parseDate(rs.data.issuedDate) : null,
          representativeIssuedDate: rs.data.representativeIssuedDate != null ? DateParseService.parseDate(rs.data.representativeIssuedDate) : null
        };
        // const bankSelect = this.listBankName.find(bank => bank.brandName === this.customer.bankName);
        // if (bankSelect) {
        //   this.customer.bankName = bankSelect.vietnameseName;
        // }
        this.customer.birthdayDisplay = this.customer.birthday ? format(this.customer.birthday, 'DD/MM/YYYY') : '';
        this.customer.issuedDateDisplay = this.customer.issuedDate ? format(this.customer.issuedDate, 'DD/MM/YYYY') : '';
        this.customer.representativeIssuedDateDisplay = this.customer.representativeIssuedDate ? format(this.customer.representativeIssuedDate,'DD/MM/YYYY') : '';
        this.customer.isNewAddress = !!rs.data.isNewAddress
        if(this.customer.isNewAddress){
          this.cities = this.cityList[0]
          this.districts = this.districtList[0]
          this.wards = this.wardList[0]
        } else {
          this.cities = this.cityList[1]
          this.districts = this.districtList[1]
          this.wards = this.wardList[1]
        }
        this.getEnterpriseType();

        // var cityItem = (this.customer.cityId != null) ? this.cities.find(x => x.id === this.customer.cityId) : undefined;
        // var districtItem = (this.customer.districtId != null) ? this.districts.find(x => x.id === this.customer.districtId) : undefined;
        // var wardItem = (this.customer.wardId != null) ? this.wards.find(x => x.id === this.customer.wardId) : undefined;
        this.addresses = {
          cityName: (this.customer.cityId != null) ? this.cities.find(x => x.id === this.customer.cityId).name : '',
          districtName: (this.customer.districtId != null) ? this.districts.find(x => x.id === this.customer.districtId).name : '',
          wardName: (this.customer.wardId != null) ? this.wards.find(x => x.id === this.customer.wardId).name : '',
        };
        this.getCertificateType();
        this.getRepresentativeCertificateType();
      }
    );
  }

  onBackClick(route: string) {
    this.router.navigate([route], {
      queryParams: {
        tenantId: this.searchtenantId,
        page: this.searchPage,
        pageSize: this.searchPageSize,
        enterpriseId: this.searchEnterpriseId,
        taxCodeOrCertificateNo: this.searchTaxCodeOrCertificateNo,
        keyword: this.searchKeyword,
        status: this.searchStatus,
        enterpriseTypeId: this.searchEnterpriseTypeId
      }
    });
  }

  onUpdateClick(route: string, id: string) {
    if(localStorage.getItem('isFromSSO') =='true'){
      window.open(this.sme_hub+'/admin/object-management','_blank');
      return
    }
    this.router.navigate([route + id], {
      queryParams: {
        tenantId: this.searchtenantId,
        page: this.searchPage,
        pageSize: this.searchPageSize,
        enterpriseId: this.searchEnterpriseId,
        taxCodeOrCertificateNo: this.searchTaxCodeOrCertificateNo,
        keyword: this.searchKeyword,
        status: this.searchStatus,
        enterpriseTypeId: this.searchEnterpriseTypeId
      }
    });
  }

  /**
   * Get user type from session storage and set to userType variable
   */
  private setUserType() {
    this.userType = this.storageService.getUserTypeFromSessionStorage();
  }

  /**
   * Get enterprise list
   */
  getEnterpriseType() {
    this.commonService.getEnterpriseType().subscribe(rs => {
      if (rs && rs.data) {
        this.enterpriseType = rs.data;
        this.customerType = this.enterpriseType.find(x => x.id === this.customer.customerType).langs;
      }
    });
  }

  /**
   * Get certificate list
   */
  getCertificateType() {
    this.commonService.getCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        this.certificateType = rs.data;
        if (this.customer.customerType !== this.personalId) {
          this.certificate = this.certificateType.find(x => x.id === this.customer.certificateId).langs;
        }
      }
    });
  }

  /**
   * Get representative certificate list
   */
  getRepresentativeCertificateType() {
    this.commonService.getRepresentativeCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        this.representativeCertificateType = rs.data;
        if (this.customer.customerType === this.personalId) {
          this.representativeCertificate = this.representativeCertificateType.find(x => x.id === this.customer.certificateId);
        } else {
          this.representativeCertificate = this.representativeCertificateType.
            find(x => x.id === this.customer.representativeCertificateId);
        }
        this.representativeCertificateName = this.representativeCertificate !== undefined ? this.representativeCertificate.langs : '';
      }
    });
  }
  getEnterpriseTypeOptions(options) {
    const data = this.customerFilter.filterOptionsData(options);
    if (data !== undefined && data !== null) {
      return data;
    } else {
      return '';
    }
  }

  checkDisplayBtnUpdateCustomer(data) {
    if(this.commonService.checkDefaultAdmin()) {
      return true;
    }
    if((this.permissions.includes(401) || this.permissions.includes(4)) && data.createdBy === localStorage.getItem('userId')) {
      return true;
    }
    if((this.permissions.includes(403) || this.permissions.includes(4)) && (this.isInforTab == 0 || this.isInforTab == 1)) {
      return true;
    }
    return false;
  }
}
